import {createFileRoute} from '@tanstack/react-router'
import {secondLevelIndexRoute} from "../../../../../../../utils/collectionListing";

export const Route = createFileRoute('/_site/users/_public_profile/wants/$username/$primarySorting/$primaryCategoryName/')({
    ...secondLevelIndexRoute("/users/wants/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName")
})
